import { Adapter } from '@mode-switch/adapt';
import { Attr, Model } from '@mode-switch/model';
import { DomainPlan, DomainQuery, PivotQuery } from '@mode-switch/query';
import { FlamingoTypes } from '@mode/shared/contract-common';

type ModeRole = FlamingoTypes.ModeRole;
type Fields = FlamingoTypes.ModeFields;

export function buildDomainQuery(
  adapter: Adapter<ModeRole>,
  model: Model<ModeRole>,
  viewName: string,
  fields: Fields
): DomainPlan<ModeRole> {
  return DomainPlan.make(
    model,
    viewName,
    DomainQuery.Table.make({
      fields: fields.map(({ formula, alias, discrete }) =>
        Adapter.Fields.make(adapter, model, viewName, formula, discrete ? Attr.Type.Discrete : Attr.Type.Continuous, {
          alias,
        })
      ),
    })
  );
}

export function buildPivotDomainQuery(
  adapter: Adapter<ModeRole>,
  model: Model<ModeRole>,
  viewName: string,
  query: PivotQuery<ModeRole>,
  fields: Fields
): DomainPlan<ModeRole> {
  return DomainPlan.pivot(
    model,
    viewName,
    DomainQuery.Pivot.make(query, {
      fields: fields.map(({ formula, alias, discrete, frame }) =>
        Adapter.Fields.make(adapter, model, viewName, formula, discrete ? Attr.Type.Discrete : Attr.Type.Continuous, {
          alias,
          frame,
        })
      ),
    })
  );
}
